import { Controller } from "@hotwired/stimulus"

// Tick which orders to move on the bulk change vendor page, keeping the
// submit button's count (and its confirm message) in step.
export default class extends Controller {
  static targets = ["order", "all", "submit", "hint"]

  toggleAll() {
    this.orderTargets.forEach(checkbox => { checkbox.checked = this.allTarget.checked })
    this.update()
  }

  update() {
    const count = this.orderTargets.filter(checkbox => checkbox.checked).length
    const label = `${count} ${count === 1 ? "order" : "orders"}`

    if (this.hasAllTarget) {
      this.allTarget.checked = count > 0 && count === this.orderTargets.length
      this.allTarget.indeterminate = count > 0 && count < this.orderTargets.length
    }
    if (this.hasSubmitTarget) {
      this.submitTarget.value = `Change vendor on ${label}`
      this.submitTarget.disabled = count === 0
      this.submitTarget.dataset.confirm = `Move ${label} to the new vendor? Their vendor payment schedules will be rebuilt.`
    }
    if (this.hasHintTarget) {
      this.hintTarget.hidden = count > 0
    }
  }

  connect() {
    this.update()
  }
}
